<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Account Group Membership</h1>
            </div>

            <div class="modal-body">
                <div class="flex h-full">
                    <div class="w-full md:w-full">
                        <p class="mb-4">Member of {{ groups.length }} groups</p>

                        <div class="row flex py-2 border-b">
                            <div class="w-1/4 font-bold px-1">Group</div>
                            <div class="w-1/2 font-bold px-1">Description</div>
                            <div class="w-1/4 font-bold px-1"></div>
                        </div>
                        <div class="row flex py-2 hover:bg-gray-200" v-for="group in groups" :key="group.id">
                            <div class="w-1/4 p-1">
                                {{ group.name }}
                            </div>
                            <div class="w-1/2 p-1">{{ group.description }}</div>
                            <div class="w-1/4 p-1 text-right"><button type="button" class="btn-danger muted small" @click.prevent="removeGroup(group)">Remove</button></div>
                        </div>

                        <div class="flex">
                            <div class="form-field flex-0">
                                <select v-model="selectedGroup">
                                    <option :value="null">-- Add a group membership --</option>
                                    <option
                                        v-for="group in availableGroups"
                                        :key="group.id"
                                        :value="group.id"
                                        :disabled="groups.filter((g) => g.id === group.id).length !== 0"
                                    >{{ group.name }}</option>
                                </select>
                            </div>
                            <div class="flex-1 pt-4">
                                <button class="btn-primary input" @click.prevent="addGroup">Add</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                        <button class="btn-primary" type="button" @click="handleUpdate">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AccountGroupsView',
        props: {},
        components: {
            //
        },
        data() {
            return {
                groups: [],
                selectedGroup: null,
                availableGroups: [],
            }
        },
        mounted() {
            this.loadData()
            this.loadAvailableGroups()
            this.setMetaTitle('Account Groups Membership | JournoLink Control')
        },
        methods: {
            loadData () {
                axios.get(route('accounts.groups', this.$route.params.accountId))
                    .then(response => {
                        this.groups = response.data
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            loadAvailableGroups() {
                axios.get(route('accounts.groups.list', { page: 1, per_page: 9999 }))
                    .then(response => {
                        this.availableGroups = response.data.results.data
                    })
                    .catch(e => {
                        console.log(error)
                    })
            },
            /**
             * Handle update
             */
            handleUpdate () {
                let groupsForUpdate = this.groups.map(g => g.id)

                axios.post(route('accounts.groups.update', this.$route.params.accountId), {
                    groups: groupsForUpdate
                }).then(response => {
                    this.$bus.$emit('alert.success', 'Update Success')
                    this.groups = response.data
                })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'Update Failed')
                })
            },
            /**
             * Add the account to the selected group
             *
             * @return {void}
             */
            addGroup() {
                if (this.selectedGroup === null) {
                    return
                }

                let groupToAdd = this.availableGroups.find(g => g.id === this.selectedGroup)
                if (groupToAdd) {
                    this.groups.push(groupToAdd)
                    this.groups = _.sortBy(this.groups, g => g.name)
                    this.selectedGroup = null
                }
            },
            /**
             * Remove a group membership from the account
             *
             * @param {Object} group
             * @return {void}
             */
            removeGroup(group) {
                this.groups = this.groups.filter(g => g.id !== group.id)
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.$parent.loadData()
                this.$root.goBack()
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        },
        computed: {
            //
        }
    }
</script>

<style lang="less" scoped>
    .features-body {
        flex: 1;
        padding: 15px;
    }

    .vdp-datepicker {
        display: inline-block;
        border: 1px solid #dddddd;
        padding: 5px;
    }

    .modal-body {
        h2, h3 {
            text-transform: uppercase;
            font-size: 1.2em;
            letter-spacing: .08em;
            color: #34495e;
            margin-bottom: 10px;
        }
    }

    p.note {
        margin: 10px 0;
        font-weight: bold;
    }
</style>
